import type { FC, PropsWithChildren } from 'react';

import { TextButton, TextButtonProps } from '@xing-com/button';
import { useFetch } from '@xing-com/crate-xinglet';

import { URL_COMPLAINTS_API_REPORTS } from '../../config/urls';

export interface Report {
  id?: string;
}
export interface ResponseProps {
  reponse: string;
  report?: Report;
}

export type ReportButtonProps = TextButtonProps & {
  authorUrn: string;
  targetUrn: string;
  onError?: () => void;
  onSuccess?: () => void;
};
export const ReportButton: FC<PropsWithChildren<ReportButtonProps>> = ({
  children,
  authorUrn,
  targetUrn,
  onError,
  onSuccess,
  ...props
}) => {
  const fetchJson = useFetch();

  const handleOnClick = async () => {
    try {
      const response = await fetchJson(URL_COMPLAINTS_API_REPORTS, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          author_urn: authorUrn,
          target_urn: targetUrn,
        }),
      });

      const redirectLocation = response.headers.get('Location');

      if (redirectLocation) {
        window.open(window.location.origin + redirectLocation);
        onSuccess?.();
      } else {
        onError?.();
      }
    } catch (error) {
      console.log('Error', error);
      onError?.();
    }
  };
  return (
    <TextButton size="small" {...props} onClick={handleOnClick}>
      {children}
    </TextButton>
  );
};
